import React, { Component } from 'react';
import SearchBar from './SeachBar';
import { Box, Button } from '@material-ui/core';

class SearchBarAction extends Component {
    state = { }
    render() {
        return (
            <Box p={1} style={{ display: "flex", justifyContent: "space-between", alignItems:"center"}}>
                <Box>
                    <Button 
                        onClick={this.props.action}
                        color="primary"
                        variant="contained"
                    >
                        Nouveau
                    </Button>
                </Box>
                <Box style={{width: '100%'}}>
                    <SearchBar {...this.props} />
                </Box>
            </Box>
        );
    }
}

export default SearchBarAction;